import { createRouter, createWebHistory } from 'vue-router'
import { SEOUtils, pageConfigs } from '@/utils/seo'
import Home from '@/views/Home.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: { 
      title: '首页 - 弥央大学',
      seoConfig: 'home'
    }
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('@/views/About.vue'),
    meta: { 
      title: '关于 - 弥央大学',
      seoConfig: 'about'
    }
  },
  {
    path: '/links',
    name: 'Links',
    component: () => import('@/views/Links.vue'),
    meta: { 
      title: '友情链接 - 弥央大学',
      seoConfig: 'links'
    }
  },
  {
    path: '/apply',
    name: 'Apply',
    component: () => import('@/views/Apply.vue'),
    meta: { 
      title: '申请入学 - 弥央大学',
      seoConfig: 'apply'
    }
  },
  {
    path: '/blog/:id',
    name: 'BlogDetail',
    component: () => import('@/views/BlogDetail.vue'),
    meta: { 
      title: '博客文章 - 弥央大学',
      seoConfig: 'blog'
    }
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('@/views/NotFound.vue'),
    meta: { 
      title: '页面未找到 - 弥央大学',
      seoConfig: null
    }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  }
})

// 路由守卫 - 更新页面标题和SEO标签
router.beforeEach((to, from, next) => {
  // 更新页面标题
  if (to.meta.title) {
    document.title = to.meta.title
  }
  
  // 应用SEO配置
  if (to.meta.seoConfig && pageConfigs[to.meta.seoConfig]) {
    const config = pageConfigs[to.meta.seoConfig]
    // 动态更新URL
    config.url = `https://mio.edu.kg${to.path}`
    SEOUtils.optimizePage(config)
  }
  
  next()
})

export default router

